/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Recommendation Video Component Styles
 *
 * @file RecommendationVideoComponentStyle.jsx
 * @author Murhsid Ahamedh
 */

import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../assets/styles/mixins.scss';

const useRemediationStyles = makeStyles(() => ({
  titleSection: {
    marginTop: 16,
    marginBottom: 20
  },
  title: {
    fontFamily: mixins.fontFamilyTT,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize22,
    lineHeight: mixins.lineHeight24,
    letterSpacing: 0,
    color: '#171717',
    verticalAlign: 'middle',
    marginBottom: 0
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    width: '100%'
  },
  widgetSection: {
    width: 'calc(33.333% - 11px)',
    maxWidth: 'calc(33.333% - 11px)',
    flexGrow: 0,
    flexShrink: 0,
    boxSizing: 'border-box',
    minHeight: '250px',
    overflow: 'hidden',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    hyphens: 'auto',
    '& *': {
      maxWidth: '100%',
      boxSizing: 'border-box'
    },
    '@media (max-width: 1024px)': {
      width: 'calc(50% - 8px)',
      maxWidth: 'calc(50% - 8px)'
    },
    '@media (max-width: 768px)': {
      width: '100%',
      maxWidth: '100%'
    }
  },
  widgetSectionTwo: {
    width: 'calc(50% - 8px)',
    maxWidth: 'calc(50% - 8px)',
    flexGrow: 0,
    flexShrink: 0,
    boxSizing: 'border-box',
    minHeight: '250px',
    overflow: 'hidden',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    hyphens: 'auto',
    '& *': {
      maxWidth: '100%',
      boxSizing: 'border-box'
    },
    '@media (max-width: 768px)': {
      width: '100%',
      maxWidth: '100%'
    }
  },
  widgetSectionSingle: {
    width: '50%',
    maxWidth: '50%',
    flexGrow: 0,
    flexShrink: 0,
    boxSizing: 'border-box',
    minHeight: '250px',
    overflow: 'hidden',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    hyphens: 'auto',
    '& *': {
      maxWidth: '100%',
      boxSizing: 'border-box'
    }
  },

  fallbackContainer: {
    background: '#fff',
    borderRadius: 12,
    padding: 16,
    border: '1px solid #e5e7eb'
  },
  fallbackTitle: {
    fontWeight: 600,
    marginBottom: 8
  },
  fallbackText: {
    color: '#6b7280'
  },
  linkContainer: {
    marginTop: 8
  }
}));

export default useRemediationStyles;

